module.exports = __webpack_public_path__ + "static/media/greenhouse3-11.f84e7c40.webp";